import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

// Modulos
import { SharedModule } from '../shared/shared.module';
import { ComponentsModule } from '../components/components.module';
import { DataTablesModule } from 'angular-datatables';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PagesComponent } from './pages.component';
import { CambiocontrasenaComponent } from './Usuarios/cambiocontrasena/cambiocontrasena.component';
import { NuevousuarioComponent } from './Usuarios/nuevousuario/nuevousuario.component';
import { PermisosModulosComponent } from './permisos-modulos/permisos-modulos.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterAspirante } from '../services/filterAspirante.pipe';
import { FilterPipeAlumGrp } from '../pipes/filterAlumGrp.pipe';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { CmAngularDualListboxModule } from 'cm-angular-dual-listbox';
import { FilterPipeGuia } from '../pipes/filterGuia.pipe';

import { ListadeplantelesComponent } from './Catalogo/listadeplanteles/listadeplanteles.component';
import { ListadoderesguardanteComponent } from './Catalogo/listadoderesguardante/listadoderesguardante.component';
import { ListadodebecasComponent } from './Recursos-humanos/listadodebecas/listadodebecas.component';
import { ListadodelentesComponent } from './Recursos-humanos/listadodelentes/listadodelentes.component';
import { ListadodeaparatosortopedicosComponent } from './Recursos-humanos/listadodeaparatosortopedicos/listadodeaparatosortopedicos.component';
import { ListadodeviaticosComponent } from './Recursos-humanos/listadodeviaticos/listadodeviaticos.component';
import { ListadodereportesComponent } from './Recursos-humanos/listadodereportes/listadodereportes.component';
import { ListadodereporteslentesComponent } from './Reportes/listadodereporteslentes/listadodereporteslentes.component';
import { ListadodereportesbecasComponent } from './Reportes/listadodereportesbecas/listadodereportesbecas.component';
import { ListadodereportespersonalComponent } from './Reportes/listadodereportespersonal/listadodereportespersonal.component';
import { ListadxmlcontabilidadComponent } from './Contabilidad/listadxmlcontabilidad/listadxmlcontabilidad.component';
import { ListadxmlmaterialesComponent } from './Recursos-materiales/listadxmlmateriales/listadxmlmateriales.component';
import { ListadxmlfinancierosComponent } from './Recursos-financieros/listadxmlfinancieros/listadxmlfinancieros.component';
import { ReportescontabilidadComponent } from './Contabilidad/reportescontabilidad/reportescontabilidad.component';
import { ReportesdiotComponent } from './Recursos-financieros/reportesdiot/reportesdiot.component'; ///planeacion



@NgModule({
  declarations: [
    DashboardComponent,
    PagesComponent,
    CambiocontrasenaComponent,
    NuevousuarioComponent,
    PermisosModulosComponent,
    FilterAspirante,
    FilterPipeAlumGrp,
    FilterPipeGuia,
      
      ListadeplantelesComponent,
      ListadoderesguardanteComponent,
      ListadodebecasComponent,
      ListadodelentesComponent,
      ListadodeaparatosortopedicosComponent,
      ListadodeviaticosComponent,
      ListadodereportesComponent,
      ListadodereporteslentesComponent,
      ListadodereportesbecasComponent,
      ListadodereportespersonalComponent,
      ListadxmlcontabilidadComponent,
      ListadxmlmaterialesComponent,
      ListadxmlfinancierosComponent,
      ReportescontabilidadComponent,
      ReportesdiotComponent///planeacion

  ],
  exports: [
DashboardComponent,
PagesComponent   
  ],
  imports: [ 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule,
    ComponentsModule,
DataTablesModule,
NgxPaginationModule,
AngularDualListBoxModule,
CmAngularDualListboxModule
  ],

})
export class PagesModule { }
